/**
 * Cell — a discrete 2D grid coordinate.
 */

export interface Cell {
  readonly row: number;
  readonly col: number;
}

/** Deterministic string key for hashing / dedup. */
export function cellKey(c: Cell): string {
  return `${c.row},${c.col}`;
}

export function cellEquals(a: Cell, b: Cell): boolean {
  return a.row === b.row && a.col === b.col;
}
